import React, { useEffect, useRef, useState } from "react";

import IsLogin from "../../utilities/functions/isLogin";
import { Link, useLocation, useNavigate } from "react-router-dom";
import apiConfig from "../../utilities/apiConfig.json";
import serverConfig from "../../utilities/serverConfig.json";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import scrollToTop from "../../utilities/functions/ScrollToTop"; // Adjust the path to where your function is located
import DepartmentImgNotFound from "./../../assets/images/department-not-found.svg";
import DepartmentCard from "./departmentCard";
import isWhitespaceString from "../../utilities/functions/isWhiteSpaceString";
import { useSelector } from "react-redux";
import haveAccess from "../../utilities/functions/haveAccess";

const DepartmentStore = () => {
  const [logIn, setLogIn] = useState();
  const navigate = useNavigate();
  const { token, roles } = useSelector((state) => state.user);
  const tokenLocal = localStorage.getItem("token");

  const headers = {
    Authorization: "Bearer " + (token ? token : tokenLocal),
  };
  const [loading, setLoading] = useState(false);

  const [clearData, setClearData] = useState(false);
  const [editing, setEditing] = useState(false);
  const [depID, setDepID] = useState();

  // data for Table
  const [departments, setDepartments] = useState();

  // data for choose parent dep
  const [parentDepartments, setParentDepartments] = useState();
  const [allDepartments, setAllDepartments] = useState();
  const [selectedParentDepartment, setSelectedParentDepartment] = useState("");

  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const dep = queryParams.get("dep") ? queryParams.get("dep") : null; // Getting the value of 'dep' from the query string
  const action = queryParams.get("action") ? queryParams.get("action") : null; // Getting the value of 'action' from the query string

  // pages variables
  const [searchValue, setSearchValue] = useState("");
  const [paginationElem, setPaginationElem] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const [perPage, setPerPage] = useState(24);

  const [preview, setPreview] = useState();
  const [departmentPhoto, setDepartmentPhoto] = useState();
  const [departmentPhotoBackend, setDepartmentPhotoBackend] = useState();
  const [departmentName, setDepartmentName] = useState("");
  const [biography, setBiography] = useState("");

  const isInitialRender = useRef(true);
  const isInitialRender2 = useRef(true);

  const departmentPhotoChangeHandler = (e) => {
    setDepartmentPhoto(e);
  };

  const biographyChangeHandler = (e) => {
    if (e != null) {
      setBiography(e);
    } else {
      setBiography("");
    }
  };

  const departmentStoreAPI = () => {
    // create a new FormData object and append the file to it
    const formData = new FormData();
    formData.append("title", departmentName);
    formData.append("parent_id", selectedParentDepartment);
    formData.append("biography", biography);
    if (departmentPhoto) {
      formData.append("file", departmentPhoto.target.files[0]);
    }

    // make a POST request to the File Upload API with the FormData object and Rapid API headers
    axios
      .post(
        serverConfig.server.url + apiConfig.api.storeAPIs.storeDepartment,
        formData,
        {
          headers,
        }
      )
      .then((response) => {
        setLoading(false);
        if (response.data.status === "success") {
          toast.success(response.data.message);
          setClearData(true);
          getParentDepartmentsAPI();
          getDepartmentsAPI();
        } else {
          if (typeof response.data.errors === typeof "String") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error making API call:", error);
      });
  };

  const departmentUpdateAPI = () => {
    setLoading(true);
    // create a new FormData object and append the file to it
    const formData = new FormData();
    formData.append("title", departmentName);
    formData.append("parent_id", selectedParentDepartment);
    formData.append("biography", biography);
    if (departmentPhoto) {
      formData.append("file", departmentPhoto.target.files[0]);
    }
    // else if (departmentPhotoBackend) {
    //   formData.append("file", departmentPhotoBackend);
    // }

    // make a POST request to the File Upload API with the FormData object and Rapid API headers
    axios
      .post(
        serverConfig.server.url +
        apiConfig.api.updateAPIs.updateDepartment +
        depID,
        formData,
        {
          headers,
        }
      )
      .then((response) => {
        setLoading(false);
        if (response.data.status === "success") {
          toast.success(response.data.message);
          setEditing(false);
          setClearData(true);
          getParentDepartmentsAPI();
          getDepartmentsAPI();
          navigate("/department-store");
        } else {
          if (typeof response.data.errors === typeof "String") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error making API call:", error);
      });
  };

  const departmentDeleteAPI = () => {
    setLoading(true);
    axios
      .get(
        serverConfig.server.url +
        apiConfig.api.deleteAPIs.deleteDepartment +
        depID,
        {
          headers,
        }
      )
      .then((response) => {
        setLoading(false);
        if (response.data.status === "success") {
          toast.success(response.data.message);
          setEditing(false);
          setClearData(true);
          getDepartmentsAPI();
          navigate("/department-store");
        } else {
          if (typeof response.data.errors === typeof "String") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);

        toast.error("Error making API call:", error);
      });
  };

  const getParentDepartmentsAPI = () => {
    setLoading(true);
    axios
      .post(
        serverConfig.server.url + apiConfig.api.getAPIs.getDepartments,
        {
          pagination: false,
        },
        { headers }
      )
      .then((response) => {
        setLoading(false);
        if (response.data.status === "success") {
          setParentDepartments(response.data.data.departments);
        } else {
          if (typeof response.data.errors === typeof "String") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error making API call:", error);
      });
  };

  const getDepartmentsAPI = () => {
    setLoading(true);
    axios
      .post(
        serverConfig.server.url +
        apiConfig.api.getAPIs.getDepartments +
        "?page=" +
        currentPage,
        {
          pagination: true,
          per_page: perPage,
          ...(isWhitespaceString(searchValue) && { search_value: searchValue }),
        },
        { headers }
      )
      .then((response) => {
        setLoading(false);
        if (response.data.status === "success") {
          setDepartments(response.data.data.departments);
          if (searchValue == "" && !allDepartments) {
            setAllDepartments(response.data.data.departments);
          }
          // pagination
          setPaginationElem();
          setPageCount(response.data.data.page_count);
          for (let i = 1; i <= response.data.data.page_count; i++) {
            setPaginationElem((prevPaginationElem) => (
              <>
                {prevPaginationElem}
                <li
                  className={"page-item" + (currentPage == i ? " active" : "")}
                >
                  <a
                    className="page-link"
                    href="#"
                    onClick={() => {
                      setCurrentPage(i);
                      scrollToTop();
                    }}
                  >
                    {i}
                  </a>
                </li>
              </>
            ));
          }
        } else {
          if (typeof response.data.errors === typeof "String") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error making API call:", error);
      });
  };

  const getDepartmentProfileAPI = () => {
    setLoading(true);
    axios
      .post(
        serverConfig.server.url + apiConfig.api.getAPIs.getDepartment + depID,
        {},
        { headers }
      )
      .then((response) => {
        setLoading(false);
        if (response.data.status === "success") {
          setDepartmentName(response.data.data.department.title);
          if (response.data.data.department.parent_id) {
            setSelectedParentDepartment(
              response.data.data.department.parent_id
            );
          } else {
            setSelectedParentDepartment("");
          }
          biographyChangeHandler(response.data.data.department.biography);
          if (response.data.data.file && response.data.data.file.length > 0) {
            setPreview(response.data.data.file);
            setDepartmentPhotoBackend(response.data.data.department.file);
          } else {
            setPreview("");
            setDepartmentPhotoBackend();
          }
        } else {
          if (typeof response.data.errors === typeof "String") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error making API call:", error);
      });
  };

  useEffect(() => {
    if (departmentPhoto) {
      // create the preview
      const objectUrl = URL.createObjectURL(departmentPhoto.target.files[0]);
      setPreview(objectUrl);

      // free memory when ever this component is unmounted
      return () => URL.revokeObjectURL(objectUrl);
    }
  }, [departmentPhoto]);

  useEffect(() => {
    const checkLoginStatus = async () => {
      const loggedIn = await IsLogin();
      setLogIn(loggedIn !== false);
      if (loggedIn === false || loggedIn === "error api") {
        localStorage.getItem("FullName") && localStorage.removeItem("FullName");
        localStorage.getItem("mobile") && localStorage.removeItem("mobile");
        localStorage.getItem("token") && localStorage.removeItem("token");
        localStorage.setItem(
          "callBackURL",
          window.location.pathname + window.location.search
        );
        navigate("/login");
      }
      getParentDepartmentsAPI();
    };

    checkLoginStatus();

    // let res = IsLogin();
    // if (res) {
    //   getDepartmentsAPI();
    // } else {
    //   navigate("/login");
    // }
  }, []);

  // pagination
  useEffect(() => {
    if (!isInitialRender2.current) {
    } else {
      isInitialRender2.current = false;
    }
    getDepartmentsAPI();
  }, [currentPage]);

  // pagination
  useEffect(() => {
    setCurrentPage(1);
    getDepartmentsAPI();
  }, [searchValue, perPage]);

  useEffect(() => {
    if (editing) {
      getDepartmentProfileAPI();
    }
  }, [editing, depID]);

  useEffect(() => {
    if (clearData) {
      setDepartmentName("");
      biographyChangeHandler("");
      setPreview();
      setDepartmentPhoto();
      setDepID("");
      setSelectedParentDepartment("");
      setClearData(false);
    }
  }, [clearData]);

  useEffect(() => {
    if (dep) {
      setEditing(true);
      setDepID(dep);
    }
  }, [dep]);

  return (
    <div className="d-flex row pt-3">
      <div>
        {/* Cards */}

        {/* select image card */}
        {logIn &&
          (haveAccess(roles, "department_add") ||
            haveAccess(roles, "department_edit")) && (
            <div className="card card-box-shadow border-0 mb-3">
              <div className="card-body d-flex row">
                {editing ? <h5>ویرایش دپارتمان</h5> : <h5>ثبت دپارتمان</h5>}
                <div className="d-flex flex-row">
                  {/* File Preview */}
                  <div className="d-flex col my-2 me-3 col-auto">
                    <img
                      className="doctor-image-box col col-auto object-fit-cover"
                      src={preview ? preview : DepartmentImgNotFound}
                    />
                  </div>

                  {/* File Uploader */}
                  <div className="d-flex col my-2 flex-column ">
                    <input
                      // className={`form-control ${preview ? "d-none" : ""}`}
                      className="form-control w-100"
                      type="file"
                      id="formFile"
                      onChange={(e) => {
                        departmentPhotoChangeHandler(e);
                      }}
                    />
                    <span className="text-secondary fs-14 fw-normal">
                      حداکثر حجم مجاز آیکون 20 کیلوبایت میباشد
                    </span>
                  </div>
                </div>

                <div className="d-flex col my-2 col-12 col-lg-6">
                  <input
                    className="form-control"
                    type="text"
                    placeholder="نام دپارتمان"
                    value={departmentName}
                    onChange={(e) => {
                      setDepartmentName(e.target.value);
                    }}
                  />
                </div>

                <div className="d-flex col my-2 col-12 col-lg-6">
                  <select
                    className="form-select"
                    aria-label="دپارتمان والد"
                    value={selectedParentDepartment}
                    onChange={(e) => {
                      setSelectedParentDepartment(e.target.value);
                    }}
                  >
                    <option value="" disabled>
                      دپارتمان والد را انتخاب کنید
                    </option>
                    {parentDepartments &&
                      parentDepartments.map((e) => (
                        <option key={e.id} value={e.id}>
                          {e.title}
                        </option>
                      ))}
                  </select>
                </div>

                <div className="d-flex col my-2 col-12">
                  <textarea
                    className="form-control"
                    placeholder="توضیحات دپارتمان (اختیاری)"
                    value={biography ? biography : ""}
                    onChange={(e) => {
                      biographyChangeHandler(e.target.value);
                    }}
                  />
                </div>

                <div className="d-flex col my-2 col-12">
                  {editing ? (
                    // <button
                    //   type="button"
                    //   className="btn btn-primary w-100"
                    //   onClick={departmentUpdateAPI}
                    // >
                    //   ویرایش دپارتمان
                    // </button>
                    <>
                      <div className="d-flex col">
                        <button
                          type="button"
                          // disabled={loadingStore}
                          className={`btn btn-primary w-100 me-12px fw-medium${loading ? " disabled" : ""
                            }`}
                          onClick={departmentUpdateAPI}
                        >
                          ویرایش دپارتمان
                          {loading && (
                            <span
                              className="spinner-border spinner-border-sm ms-1"
                              role="status"
                              aria-hidden="true"
                            />
                          )}
                        </button>
                      </div>
                      <div className="d-flex col">
                        <button
                          type="button"
                          // disabled={loadingStore}
                          className="btn btn-outline-primary w-100 mx-12px fw-medium"
                          onClick={() => {
                            setClearData(true);
                            setEditing(false);
                            navigate("/department-store");
                          }}
                        >
                          انصراف
                        </button>
                      </div>
                      {haveAccess(roles, "place_edit") && (
                        <div className="d-flex col-auto">
                          <button
                            type="button"
                            className={`btn btn-link color-bootstrap-regular-danger text-decoration-none w-100 px-4 ms-12px fw-medium${loading ? " disabled" : ""
                              }`}
                            onClick={departmentDeleteAPI}
                          >
                            حذف
                          </button>
                        </div>
                      )}
                    </>
                  ) : (
                    <button
                      type="button"
                      className={`btn btn-primary w-100 ${loading ? " disabled" : ""
                        }`}
                      onClick={departmentStoreAPI}
                    >
                      ثبت دپارتمان
                      {loading && (
                        <span
                          className="spinner-border spinner-border-sm ms-1"
                          role="status"
                          aria-hidden="true"
                        />
                      )}
                    </button>
                  )}
                </div>
              </div>
            </div>
          )}

        <div>
          <div className="card card-box-shadow border-0 mb-3">
            <div className="card-body d-flex flex-column">
              <div className="d-flex align-items-center mb-2">
                <p className="col fs-18 fw-medium w-auto m-0">
                  لیست دپارتمان ها
                </p>
                <div className="d-flex w-auto">
                  <input
                    className="form-control ms-1 col"
                    type="text"
                    placeholder="جستجوی نام دپارتمان"
                    value={searchValue}
                    onChange={(e) => {
                      setSearchValue(e.target.value);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          {loading && (
            <span
              className="spinner-border spinner-border ms-1"
              role="status"
              aria-hidden="true"
            />
          )}
          {departments && (
            <>
              <div className="d-flex row g-3 mt-0">
                {departments.map((department, index) => (
                  <div key={index} className="col-lg-4 col-md-6 col-12">
                    <DepartmentCard
                      departmentId={department.id}
                      departmentTitle={department.title}
                      departmentBiography={department.biography}
                      files={department.file}
                      edit={true}
                    />
                  </div>
                ))}

                <nav aria-label="Page navigation example">
                  <ul className="pagination">
                    {currentPage !== 1 && (
                      <li className="page-item">
                        <a
                          className="page-link"
                          disabled
                          href="#"
                          aria-label="Previous"
                          onClick={() => {
                            setCurrentPage(currentPage - 1);
                            scrollToTop();
                          }}
                        >
                          <span aria-hidden="true">&laquo;</span>
                        </a>
                      </li>
                    )}
                    {paginationElem}
                    {pageCount != currentPage && (
                      <li className="page-item">
                        <a
                          className="page-link"
                          disabled
                          href="#"
                          aria-label="Next"
                          onClick={() => {
                            setCurrentPage(currentPage + 1);
                            scrollToTop();
                          }}
                        >
                          <span aria-hidden="true">&raquo;</span>
                        </a>
                      </li>
                    )}
                  </ul>
                </nav>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default DepartmentStore;
